import React from 'react';
import { Box, BoxProps, ComponentWithAs, forwardRef, Image } from '@chakra-ui/react';

const Ppussung: ComponentWithAs<'div', BoxProps> = forwardRef<BoxProps, 'div'>((props, ref) => {
  return (
    <Box ref={ref} {...props}>
      <Image
        src={'/ppussung.png'}
        boxSize={'128px'}
        transform={'scaleX(-1)'}
        filter={'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));'}
      />
    </Box>
  );
});

export default Ppussung;
